import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function SiteHeader() {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b-2 border-stone-200 bg-white">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-emerald-600 text-white">
            <i className="ri-table-line w-5 h-5 flex items-center justify-center" aria-hidden="true" />
          </span>
          <span className="font-heading text-lg font-bold text-stone-900">USFansLink</span>
        </Link>

        <nav className="hidden items-center gap-6 md:flex">
          <Link to="/" className="flex items-center gap-1.5 text-[15px] font-semibold text-stone-800 hover:text-emerald-700 whitespace-nowrap cursor-pointer">
            <i className="ri-home-4-line w-4 h-4 flex items-center justify-center" aria-hidden="true" />
            {t('nav.home')}
          </Link>
          <a href="#categories" className="flex items-center gap-1.5 text-[15px] font-semibold text-stone-800 hover:text-emerald-700 whitespace-nowrap cursor-pointer">
            <i className="ri-grid-line w-4 h-4 flex items-center justify-center" aria-hidden="true" />
            {t('nav.categories')}
          </a>
          <Link to="/usfans-spreadsheet-guide" className="flex items-center gap-1.5 text-[15px] font-semibold text-stone-800 hover:text-emerald-700 whitespace-nowrap cursor-pointer">
            <i className="ri-shopping-bag-3-line w-4 h-4 flex items-center justify-center" aria-hidden="true" />
            {t('nav.shoppingGuide')}
          </Link>
        </nav>

        <div className="flex items-center gap-3">
          <LanguageSwitcher />
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="hidden rounded-md bg-emerald-600 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-700 whitespace-nowrap sm:inline-flex cursor-pointer"
          >
            {t('nav.explore')}
          </a>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-stone-300 text-stone-800 md:hidden cursor-pointer"
            aria-label="Menu"
          >
            <i className={menuOpen ? 'ri-close-line w-5 h-5 flex items-center justify-center' : 'ri-menu-line w-5 h-5 flex items-center justify-center'} aria-hidden="true" />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-stone-200 bg-white px-4 py-4 md:hidden">
          <div className="flex flex-col gap-1">
            <Link to="/" onClick={() => setMenuOpen(false)} className="flex items-center gap-2 rounded-md px-3 py-2.5 text-[15px] font-semibold text-stone-800 hover:bg-stone-50">
              <i className="ri-home-4-line w-5 h-5 flex items-center justify-center" aria-hidden="true" />
              {t('nav.home')}
            </Link>
            <Link to="/usfans-spreadsheet-guide" onClick={() => setMenuOpen(false)} className="flex items-center gap-2 rounded-md px-3 py-2.5 text-[15px] font-semibold text-stone-800 hover:bg-stone-50">
              <i className="ri-shopping-bag-3-line w-5 h-5 flex items-center justify-center" aria-hidden="true" />
              {t('nav.shoppingGuide')}
            </Link>

            <div className="mt-3 border-t border-stone-100 pt-3">
              <p className="px-3 text-xs font-semibold uppercase tracking-wide text-stone-400">{t('nav.categories')}</p>
              <div className="mt-2 grid grid-cols-2 gap-1.5">
                {categories.map((cat) => (
                  <a
                    key={cat.key}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-1.5 rounded-md border border-stone-200 px-2.5 py-2 text-sm font-medium text-stone-700 hover:bg-stone-50 whitespace-nowrap"
                  >
                    <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center text-emerald-600" aria-hidden="true" />
                    {t(`categories.items.${cat.key}`)}
                  </a>
                ))}
              </div>
            </div>

            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="mt-3 rounded-md bg-emerald-600 px-3 py-2.5 text-center text-sm font-semibold text-white"
            >
              {t('nav.explore')}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}